import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Box, Skeleton } from '@mui/material';

const styles: IStyles = {
  card: {
    width: '100%',
    border: '1px solid #CED2FC',
    borderRadius: { xs: pxToRem(15), md: pxTovW(15) },
    backgroundColor: 'common.white',
    overflow: 'hidden',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(16), md: pxTovW(20) },
    padding: {
      xs: `${pxToRem(20)} ${pxToRem(10)}`,
      md: `${pxTovW(20)} ${pxTovW(50)}`,
    },
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(8), md: pxTovW(10) },
  },
  questionNumber: {
    width: { xs: pxToRem(36), md: pxTovW(48) },
    height: { xs: pxToRem(18), md: pxTovW(22) },
  },
  marksPill: {
    width: { xs: pxToRem(64), md: pxTovW(80) },
    height: { xs: pxToRem(24), md: pxTovW(28) },
    borderRadius: { xs: pxToRem(16), md: pxTovW(20) },
  },
  addButton: {
    marginLeft: 'auto',
    width: { xs: pxToRem(64), md: pxTovW(80) },
    height: { xs: pxToRem(32), md: pxTovW(36) },
    borderRadius: { xs: pxToRem(8), md: pxTovW(10) },
  },
  questionLines: {
    display: 'flex',
    flexDirection: 'column',
    gap: pxToRem(8),
  },
  questionLineLong: {
    width: '92%',
    height: pxToRem(18),
  },
  questionLineShort: {
    width: '64%',
    height: pxToRem(18),
  },
  optionGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: { xs: pxToRem(10), md: pxTovW(16) },
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(12) },
    border: '1px solid #E4E6F5',
    borderRadius: { xs: pxToRem(10), md: pxTovW(12) },
    padding: { xs: pxToRem(10), md: pxTovW(14) },
  },
  optionCircle: {
    width: pxToRem(28),
    height: pxToRem(28),
  },
  optionText: {
    width: '70%',
    height: pxToRem(16),
  },
  footerRow: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(16), md: pxTovW(24) },
  },
  footerTime: {
    width: pxToRem(56),
    height: pxToRem(16),
  },
  footerMeta: {
    marginLeft: 'auto',
    display: 'flex',
    gap: pxToRem(16),
  },
  footerBloom: {
    width: pxToRem(96),
    height: pxToRem(16),
  },
  footerDifficulty: {
    width: pxToRem(64),
    height: pxToRem(16),
  },
  correctAnswer: {
    width: '100%',
    height: { xs: pxToRem(44), md: pxTovW(52) },
    bgcolor: '#F4F7FF',
  },
};

const QuestionBankCardSkeletonItem = () => (
  <Box sx={styles.card}>
    <Box sx={styles.body}>
      <Box sx={styles.headerRow}>
        <Skeleton variant="rounded" sx={styles.questionNumber} />
        <Skeleton variant="rounded" sx={styles.marksPill} />
        <Skeleton variant="rounded" sx={styles.addButton} />
      </Box>

      <Box sx={styles.questionLines}>
        <Skeleton variant="rounded" sx={styles.questionLineLong} />
        <Skeleton variant="rounded" sx={styles.questionLineShort} />
      </Box>

      <Box sx={styles.optionGrid}>
        {Array.from({ length: 4 }).map((_, index) => (
          <Box key={index} sx={styles.option}>
            <Skeleton variant="circular" sx={styles.optionCircle} />
            <Skeleton variant="rounded" sx={styles.optionText} />
          </Box>
        ))}
      </Box>

      <Box sx={styles.footerRow}>
        <Skeleton variant="rounded" sx={styles.footerTime} />
        <Box sx={styles.footerMeta}>
          <Skeleton variant="rounded" sx={styles.footerBloom} />
          <Skeleton variant="rounded" sx={styles.footerDifficulty} />
        </Box>
      </Box>
    </Box>

    <Skeleton variant="rectangular" sx={styles.correctAnswer} />
  </Box>
);

export const QuestionBankCardSkeleton = () => (
  <>
    {Array.from({ length: 3 }).map((_, index) => (
      <QuestionBankCardSkeletonItem key={index} />
    ))}
  </>
);
